import { useReducer } from 'react';
import { ADD_RESPONSE, REMOVE_RESPONSE, RESET_RESPONSES } from '@BUP/constants';

const initialState = {
  responses: [],
};

const checkHasResponse = (responses, responseId) =>
  !!responses.find((response) => response.responseId === responseId);

const selectedResponsesReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case ADD_RESPONSE: {
      const hasResponse = checkHasResponse(
        state.responses,
        action.payload.responseId
      );
      if (hasResponse) {
        const responseIndex = state.responses.findIndex(
          (response) => response.responseId === action.payload.responseId
        );
        const currentResponses = [...state.responses];
        currentResponses[responseIndex] = action.payload;
        return { ...state, responses: [...currentResponses] };
      }
      return { ...state, responses: [...state.responses, action.payload] };
    }
    case REMOVE_RESPONSE: {
      const filteredResponses = state.responses.filter(
        (response) => response.responseId !== action.payload.responseId
      );
      return { ...state, responses: filteredResponses };
    }
    case RESET_RESPONSES:
      console.log('reset state');
      return { ...state, responses: [] };
    default:
      return state;
  }
};

export function useSelectedResponses() {
  const [state, dispatchSelectedResponses] = useReducer(
    selectedResponsesReducer,
    initialState
  );

  return {
    selectedResponses: state.responses,
    dispatchSelectedResponses,
  };
}
